import { STUDENT_APPLICATION_PILL } from '@/shared/utils/statusPills';

// Colour and label for each student application status, from the one map in
// statusPills.js
export const STUDENT_APP_STATUS = STUDENT_APPLICATION_PILL;
